export enum ExplorerTransactionType {
  TRANSACTION = 'tx',
  ADDRESS = 'address',
}
